



























































































































































































































































































import api from '@/services/api';
import { Component, Vue, Prop } from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import UserProfile from '@/classes/UserProfile';
import TRAINMemberProfile from '@/classes/TRAINMemberProfile';
import 'bootstrap';
import bootbox from 'bootbox';
import _ from 'underscore';
import { phoneFormatter } from '@/services/inputTools';
import { NAME_REGEX, EMAIL_REGEX } from '@/validation';

@Component
export default class UserForm extends Vue {
  @Prop() public id!: string | number;
  public edit: boolean = false;
  public jobCorpCenterSelected: any = null;
  public loadedUser: UserProfile | null = new UserProfile();
  public disableReset: boolean = false;
  public lookupPressed: boolean = false;
  public lockUbcId: boolean = false;
  public lockFields: boolean = true;
  public showForm: boolean = false;
  public loading: boolean = false;

  public showNoUbcIdFoundPrompt: boolean = false;

  public form: any = {
    emailAddress: undefined,
    ubcId: undefined,
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
    suffix: undefined,
    title: undefined,
    affiliateId: undefined,
    cellPhoneNumber: undefined,
    workPhoneNumber: undefined,
    workPhoneNumberExt: undefined,
    faxNumber: undefined,
    emergencyContactName: undefined,
    emergencyContactRelationship: undefined,
    emergencyContactDayPhoneNumber: undefined,
    emergencyContactDayPhoneNumberExt: undefined,
    emergencyContactNightPhoneNumber: undefined,
    emergencyContactNightPhoneNumberExt: undefined,
    securityLevel: undefined,
    jobCorpsCenterIds: [],
    jobCorpsCenterPrimaryId: undefined,
    reactivated: null,
    reactivatedByUserId: null,
    deactivated: null,
    deactivatedByUserId: null
  };

  public created() {
    this.updateForm();
  }

  public updateForm() {
    if (this.$props.id) {
      const userProfiles: UserProfile[] = this.$store.getters.getUserProfileList;
      const loader = new Promise((resolve, reject) => {
        if (userProfiles.length === 0) {
          this.$store.dispatch('loadUserProfiles').then(resolve).catch(reject);
        } else {
          resolve();
        }
      });
      loader.then(() => {
        this.loadedUser = this.$store.getters.getUserProfileById(this.$props.id);
        if (this.loadedUser) {
          this.edit = true;
          const tempForm = this.form;
          this.form = { ...tempForm, ...this.loadedUser };
          this.showForm = true;
          this.lockUbcId = true;
          this.lockFields = this.checkUBCId !== null ? this.checkUBCId : false;
          this.form.cellPhoneNumber = phoneFormatter(this.form.cellPhoneNumber, {});
          this.form.workPhoneNumber = phoneFormatter(this.form.workPhoneNumber, {});
          this.form.faxNumber = phoneFormatter(this.form.faxNumber, {});
          this.form.emergencyContactDayPhoneNumber = phoneFormatter(this.form.emergencyContactDayPhoneNumber, {});
          this.form.emergencyContactNightPhoneNumber = phoneFormatter(this.form.emergencyContactNightPhoneNumber, {});
        }
      });
    }
  }

  public get emailAddress(): string {
    return (this.form.emailAddress || '').trim().toLowerCase();
  }

  public set emailAddress(value: string) {
    this.form.emailAddress = value;
  }

  public get emailAddressIsInUse(): boolean {
    if (_(this.emailAddress).isEmpty()) {
      return false;
    }

    const userProfiles: UserProfile[] = this.$store.getters.getUserProfileList;
    const profilesWithEmailAddress: UserProfile[] = userProfiles.filter((u) => (u.emailAddress || '').toLowerCase() === this.emailAddress);

    if (_(profilesWithEmailAddress).isEmpty()) {
      return false;
    }

    const found: UserProfile | null = _(profilesWithEmailAddress).find((u) => u.id === (this.loadedUser || {}).id) || null;

    // If the loaded user isn't one of the users with this email address, it is considered already in use
    return _(found).isNull();
  }

  public get emailFeedback(): string {
    switch (true) {
      case _(this.emailAddress).isEmpty():
      case !EMAIL_REGEX.test(this.emailAddress):
        return 'A valid Email Address is required.';
      case this.emailAddressIsInUse:
        return 'This Email Address is already in use.';
      default:
        return 'Unknown'; // Shouldn't ever fall in here
    }
  }

  public get emailCheck(): boolean {
    return !this.emailAddressIsInUse && EMAIL_REGEX.test(this.emailAddress);
  }

  public get firstName(): string {
    return (this.form.firstName || '').trim();
  }

  public set firstName(value: string) {
    this.form.firstName = value;
  }

  public get firstNameCheck(): boolean {
    return NAME_REGEX.test(this.firstName);
  }

  public get middleName(): string {
    return (this.form.middleName || '').trim();
  }

  public set middleName(value: string) {
    this.form.middleName = value;
  }

  public get middleNameCheck(): boolean | null {
    if (_(this.middleName).isEmpty()) {
      return null;
    }

    return NAME_REGEX.test(this.middleName);
  }

  public get lastName(): string {
    return (this.form.lastName || '').trim();
  }

  public set lastName(value: string) {
    this.form.lastName = value;
  }

  public get lastNameCheck(): boolean {
    return NAME_REGEX.test(this.lastName);
  }

  public get titleCheck(): boolean {
    return !_(this.form.title).isEmpty();
  }

  private validateForm(): boolean {
    const errors: string[] = [];

    if (_(['FIELD_COORDINATOR', 'INSTRUCTOR']).contains(this.form.securityLevel) && _(this.form.jobCorpsCenterIds).isEmpty()) {
      errors.push('A Job Corp Center must be selected.');
    }

    if (!this.emailCheck) {
      errors.push(this.emailFeedback);
    }

    if (!this.firstNameCheck) {
      errors.push('Please enter a valid First Name');
    }

    // We need to compare against false.  Since middle name is optional
    // it /may/ return null, which is a false value, which we should ignore here
    if (false === this.middleNameCheck) {
      errors.push('Please enter a valid Middle Name');
    }

    if (!this.lastNameCheck) {
      errors.push('Please enter a valid Last Name');
    }

    const isValid = _(errors).isEmpty();

    if (!isValid) {
      bootbox.alert(`
      <div style="font-weight:bold">Please correct the following:</div>
      <div style="padding-top: 10px">
        <ol>
          <li>${errors.join('</li><li>')}</li>
        </ol>
      </div>`);
    }

    return isValid;
  }

  private sendForm() {
    if (!this.validateForm()) {
      return;
    }

    api()
      .post(`profile/${this.edit ? 'edit' : 'add'}`, this.form)
      .then(() => {
        this.$store.dispatch('loadUserProfiles').finally(() => {
          if (this.id !== undefined) {
            bootbox.alert(`${this.firstName} ${this.lastName} has been saved.`, () => this.$router.push('/administration/user/profile/' + this.id));
          } else {
            bootbox.alert(`${this.firstName} ${this.lastName} as been added.`, () => this.$router.push('/administration/user/search'));
          }
        });
      })
      .catch((e) => {
        if (e.response.data.message === 'Email address is taken.') {
          bootbox.alert(e.response.data.message);
        } else {
          bootbox.alert('Something went wrong.');
        }
      });
  }

  private deactivateUser() {
    const url: string = 'profile/deactivate';

    bootbox.confirm('Deactivate User?', (okClicked: boolean) => {
      if (okClicked) {
        api()
          .post(url, {
            userId: this.id
          })
          .then((response) => {
            if (response.data.success) {
              this.$store.dispatch('loadUserProfiles').then(() => {
                bootbox.alert(response.data.message);
                this.updateForm();
              });
            } else {
              bootbox.alert(response.data.message);
            }
          })
          .catch((e) => {
            bootbox.alert(e.response.data.message);
          });
      }
    });
  }

  private reactivateUser() {
    const url: string = 'profile/reactivate';

    bootbox.confirm('Reactivate User?', (okClicked: boolean) => {
      if (okClicked) {
        api()
          .post(url, {
            userId: this.id
          })
          .then((response) => {
            if (response.data.success) {
              this.$store.dispatch('loadUserProfiles').then(() => {
                bootbox.alert(response.data.message);
                this.updateForm();
              });
            } else {
              bootbox.alert(response.data.message);
            }
          })
          .catch((e) => {
            bootbox.alert(e.response.data.message);
          });
      }
    });
  }

  private addJobCorpsCenter() {
    if (this.jobCorpCenterSelected) {
      this.form.jobCorpsCenterIds.push(this.jobCorpCenterSelected.id);
    }
    this.jobCorpCenterSelected = undefined;
  }

  get jobCorpCenters() {
    return this.$store.getters.getJobCorpsCenters;
  }

  get showJobCorpsCenterSelection() {
    const arr = ['FIELD_COORDINATOR', 'INSTRUCTOR'];
    return arr.includes(this.form.securityLevel);
  }

  get allowMultipleJobCorps() {
    const arr = ['FIELD_COORDINATOR'];
    return arr.includes(this.form.securityLevel);
  }

  private getJobCorpsCenterName(id: number): string {
    const center: JobCorpsCenter = this.$store.getters.getJobCorpsCenterById(id);
    if (center && center.name !== undefined && center.name !== null) {
      return center.name;
    } else {
      return '';
    }
  }

  private emptyJobCorpsCenterIds(): void {
    this.form.jobCorpsCenterIds.splice(0);
    this.form.jobCorpsCenterPrimaryId = undefined;
  }

  private removeCenter(center: number) {
    if (center) {
      const index: number = this.form.jobCorpsCenterIds.findIndex((id: number) => id === center);
      if (index > -1) {
        this.form.jobCorpsCenterIds.splice(index, 1);
      }
      if (center === this.form.jobCorpsCenterPrimaryId) {
        this.form.jobCorpsCenterPrimaryId = undefined;
      }
    }
  }

  private sendPasswordReset(): void {
    bootbox.confirm('Reset User\'s password?', (okClicked: boolean) => {
      if (okClicked) {
        api()
          .post('resetpassword/' + this.id)
          .then(() => {
            bootbox.alert('Password has been reset, user has been emailed.');
            this.disableReset = true;
          })
          .catch(() => {
            bootbox.alert('There was an issue resetting the user\'s password.');
          });
      }
    });
  }

  private resetUserForm(): void {
    this.form.emailAddress = undefined;
    this.form.ubcId = undefined;
    this.form.firstName = undefined;
    this.form.middleName = undefined;
    this.form.lastName = undefined;
    this.form.suffix = undefined;
    this.form.title = undefined;
    this.form.affiliateId = undefined;
    this.form.cellPhoneNumber = undefined;
    this.form.workPhoneNumber = undefined;
    this.form.faxNumber = undefined;
    this.form.emergencyContactName = undefined;
    this.form.emergencyContactRelationship = undefined;
    this.form.emergencyContactDayPhoneNumber = undefined;
    this.form.emergencyContactDayPhoneNumberExt = undefined;
    this.form.emergencyContactNightPhoneNumber = undefined;
    this.form.emergencyContactNightPhoneNumberExt = undefined;
    this.form.securityLevel = undefined;
    this.form.jobCorpsCenterIds = [];
    this.lookupPressed = false;
    this.lockUbcId = false;
    this.lockFields = false;
    this.showForm = false;
  }
  get checkUBCId(): boolean | null {
    const regExpDigit = /^[Uu]?\d{8}$/;
    if (!this.form.ubcId || this.form.ubcId.length === 0) {
      return null;
    } else if (!regExpDigit.test(this.form.ubcId)) {
      return false;
    } else {
      return true;
    }
  }
  get checkUBCIdString(): string {
    return this.checkUBCId ? '' : 'Please enter a valid 8 digit UBC ID.';
  }

  private lookupUBCId() {
    this.loading = true;
    api()
      .post('profile/search/train', {
        ubcId: this.form.ubcId
      })
      .then((response) => {
        if (response.data.profileFound) {
          if (response.data.duplicate === true) {
            const userFound: UserProfile = UserProfile.userProfileFromAPI(response.data.user);
            const alertString: string = `This UBC ID belongs to ${userFound.getFullName()} and has the email address: ${userFound.emailAddress}`;
            bootbox.alert(alertString);
            this.resetUserForm();
          } else {
            bootbox.alert('Profile found.');
            this.setupUserForm(TRAINMemberProfile.memberProfileFromAPI(response.data.profile));
            this.lockUbcId = true;
            this.lockFields = true;
            this.showForm = true;
            this.lookupPressed = true;
          }
        } else {
          this.showNoUbcIdFoundPrompt = true;
        }
      })
      .catch((e) => {
        bootbox.alert('There was an issue communicating with the server.');
      })
      .finally(() => {
        this.loading = false;
      });
  }
  private setupUserForm(profile: TRAINMemberProfile) {
    if (profile !== null) {
      this.form.ubcId = profile.ubcId;
      this.form.firstName = profile.firstName;
      this.form.middleName = profile.middleName;
      this.form.lastName = profile.lastName;
      this.form.suffix = profile.suffix;
      this.form.affiliateId = profile.affiliateId;
      this.form.emergencyContactName = profile.emergencyContactName;
      this.form.emergencyContactRelationship = profile.emergencyContactRelationship;
      this.form.emergencyContactDayPhoneNumber = profile.emergencyContactDayPhoneNumber;
      this.form.emergencyContactDayPhoneNumberExt = profile.emergencyContactDayPhoneNumberExt;
      this.form.emergencyContactNightPhoneNumber = profile.emergencyContactNightPhoneNumberExt;
      this.form.emergencyContactNightPhoneNumberExt = profile.emergencyContactNightPhoneNumberExt;
    }
  }

  private proceedWithoutUbcId() {
    this.form.ubcId = undefined;
    this.lockUbcId = true;
    this.lookupPressed = true;
    this.showForm = true;
    this.lockFields = false;
  }

  private getUserProfileName(id: number) {
    const user = this.$store.getters.getUserProfileById(id);
    if (user) {
      return user.getFullName();
    } else {
      return '';
    }
  }
}
